import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SessionStorageService {
  set(key: string, value: unknown, JSONstringify = true) {
    value = JSONstringify ? JSON.stringify(value) : value;
    sessionStorage.setItem(key, value as string);
  }

  get(key: string) {
    return sessionStorage.getItem(key);
  }

  getParsed(key: string) {
    const stored = this.get(key);
    try {
      return JSON.parse(stored);
    } catch (e) {
      console.error('Error parsing stored value', e);
    }
  }

  remove(key: string) {
    sessionStorage.removeItem(key);
  }

  clear() {
    sessionStorage.clear();
  }
}
